import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';

export const pantherRedirectGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean | UrlTree => {
  const router = inject(Router);
  const platform = route.queryParamMap.get('platform');
  if (platform?.toLowerCase() === 'panther') {
    localStorage.setItem('platform', 'panther');
    return router.createUrlTree(['/signup-personal-info']);
  }
  return true;
};
